import React, { useCallback } from 'react';

const ConversationItem = ({ 
    conversation, 
    isActive, 
    hasActiveDropdown,
    onSelect, 
    onMenuClick 
}) => {
    const handleClick = useCallback(() => {
        onSelect(conversation);
    }, [conversation, onSelect]);

    const handleMenuClick = useCallback((e) => {
        e.stopPropagation();
        onMenuClick(e, conversation.timestamp);
    }, [conversation.timestamp, onMenuClick]);

    const truncatedMessage = conversation.message.length > 40 
        ? `${conversation.message.substring(0, 40)}...` 
        : conversation.message;

    return (
        <div
            className={`conversation-item 
                ${isActive ? 'active' : ''} 
                ${hasActiveDropdown ? 'dropdown-active' : ''}`}
            onClick={handleClick}
            role="button"
            tabIndex={0}
            aria-current={isActive ? 'true' : 'false'}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleClick();
                }
            }}
        >
            <div className="conversation-content">
                <div className="conversation-title" title={conversation.message}>
                    {truncatedMessage}
                </div>
            </div>
            <div className="conversation-actions">
                <button
                    className={`menu-btn ${hasActiveDropdown ? 'active' : ''}`}
                    onClick={handleMenuClick}
                    aria-label="Conversation options"
                    aria-expanded={hasActiveDropdown}
                    aria-haspopup="true"
                >
                    ⋯
                </button>
            </div>
        </div>
    );
};

export default React.memo(ConversationItem);